export enum UserRole {
  ADMIN = 'Admin',
  MANAGER = 'Manager',
  USER = 'User'
}

export interface User {
  id: string
  firstName: string
  lastName: string
  email: string
  role: UserRole
  status: 'Active' | 'Inactive'
  phoneNumber: string
  verifiedAt: string | null
}

export interface UserWithPassword extends User {
  password: string
}

export interface AuthState {
  user: User | null
  token: string | null
  isAuthenticated: boolean
}
